import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import { Plan } from "../../components/layout/Plan/Plan";

export default function SubscriptionPage() {
  return (
    <Layout>
      <Header></Header>
      <Plan></Plan>
    </Layout>
  );
}
